import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/**
 * UI state for global UI elements
 */
export interface UiState {
  /** Whether the sidebar is expanded */
  sidebarExpanded: boolean;
  /** Whether the notifications panel is open */
  notificationsPanelOpen: boolean;
  /** Currently active modal identifier, null if no modal is open */
  activeModal: string | null;
}

const initialState: UiState = {
  sidebarExpanded: false,
  notificationsPanelOpen: false,
  activeModal: null,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    /**
     * Toggle sidebar expanded state
     */
    toggleSidebar: (state) => {
      state.sidebarExpanded = !state.sidebarExpanded;
    },

    /**
     * Set sidebar expanded state explicitly
     */
    setSidebarExpanded: (state, action: PayloadAction<boolean>) => {
      state.sidebarExpanded = action.payload;
    },

    /**
     * Toggle notifications panel
     */
    toggleNotificationsPanel: (state) => {
      state.notificationsPanelOpen = !state.notificationsPanelOpen;
    },

    /**
     * Set notifications panel open state explicitly
     */
    setNotificationsPanelOpen: (state, action: PayloadAction<boolean>) => {
      state.notificationsPanelOpen = action.payload;
    },

    /**
     * Open a modal by identifier
     */
    openModal: (state, action: PayloadAction<string>) => {
      state.activeModal = action.payload;
    },

    /**
     * Close the currently active modal
     */
    closeModal: (state) => {
      state.activeModal = null;
    },
  },
});

export const {
  toggleSidebar,
  setSidebarExpanded,
  toggleNotificationsPanel,
  setNotificationsPanelOpen,
  openModal,
  closeModal,
} = uiSlice.actions;

export default uiSlice.reducer;

